import { sample as _sample } from 'openapi-sampler';
const createHar = function (openApi, path, method, queryParamValues) {
    if (typeof queryParamValues === 'undefined') {
        queryParamValues = {};
    }
    const baseUrl = getBaseUrl(openApi, path, method);
    const baseHar = {
        method: method.toUpperCase(),
        url: baseUrl + getFullPath(openApi, path, method),
        headers: getHeadersArray(openApi, path, method),
        queryString: getQueryStrings(openApi, path, method, queryParamValues),
        httpVersion: 'HTTP/1.1',
        cookies: getCookies(openApi, path, method),
        headersSize: 0,
        bodySize: 0,
    };
    let hars = [];
    const postDatas = getPayloads(openApi, path, method);
    if (postDatas.length > 0) {
        for (let i in postDatas) {
            const postData = postDatas[i];
            const copiedHar = JSON.parse(JSON.stringify(baseHar));
            copiedHar.postData = postData;
            copiedHar.comment = postData.mimeType;
            copiedHar.headers.push({
                name: 'content-type',
                value: postData.mimeType,
            });
            hars.push(copiedHar);
        }
    }
    else {
        hars = [baseHar];
    }
    return hars;
};
const isPrimitive = function (value) {
    if (value === null)
        return true;
    const valueType = typeof value;
    if (valueType === 'function' || valueType === 'object')
        return false;
    return true;
};
const getPrefix = function (style) {
    if (style === 'label') {
        return '.';
    }
    if (style === 'matrix') {
        return ';';
    }
    return '';
};
const getSeparator = function (style) {
    if (style === 'label')
        return '.';
    if (style === 'matrix')
        return ';';
    return ',';
};
const getParamId = function (style, name) {
    if (style === 'matrix')
        return `${name}=`;
    return '';
};
const getDefaultStyleForLocation = function (location) {
    if (location === 'path' || location === 'header') {
        return 'simple';
    }
    else if (location === 'query' || location === 'cookie') {
        return 'form';
    }
    return 'simple';
};
const getDefaultExplodeForStyle = function (style) {
    return style === 'form';
};
const getArrayElementSeparator = function (style) {
    let separator = ',';
    if (style === 'spaceDelimited') {
        separator = ' ';
    }
    else if (style === 'pipeDelimited') {
        separator = '|';
    }
    return separator;
};
const objectJoin = function (obj, keyValueSeparator = ',', pairSeparator = ',') {
    return Object.entries(obj)
        .map(([k, v]) => `${k}${keyValueSeparator}${v}`)
        .join(pairSeparator);
};
export const createHarParameterObjects = function ({ name, in: location, style, explode }, value) {
    if (!name || !location || typeof value === 'undefined') {
        throw 'Required parameters missing';
    }
    const prefix = getPrefix(style);
    const paramId = getParamId(style, name);
    if (isPrimitive(value)) {
        return [{ name, value: prefix + paramId + value }];
    }
    const objects = [];
    let resolvedStyle = style || getDefaultStyleForLocation(location);
    let resolvedExplode = explode || getDefaultExplodeForStyle(resolvedStyle);
    if (location === 'query' || location === 'cookie') {
        const separator = getArrayElementSeparator(resolvedStyle);
        if (Array.isArray(value)) {
            if (resolvedExplode) {
                objects.push(...value.map((entry) => {
                    return { name, value: entry + '' };
                }));
            }
            else {
                objects.push({ name, value: value.join(separator) });
            }
        }
        else if (value && typeof value === 'object') {
            if (resolvedStyle === 'deepObject') {
                objects.push(...Object.entries(value).map(([k, v]) => {
                    return { name: `${name}[${k}]`, value: v + '' };
                }));
            }
            else if (resolvedExplode) {
                objects.push(...Object.entries(value).map(([k, v]) => {
                    return { name: k, value: v + '' };
                }));
            }
            else {
                objects.push({
                    name,
                    value: objectJoin(value),
                });
            }
        }
    }
    else if (location === 'path' || location === 'header') {
        const separator = getSeparator(resolvedStyle);
        if (Array.isArray(value)) {
            objects.push({
                name,
                value: prefix + paramId + value.join(resolvedExplode ? separator + paramId : ','),
            });
        }
        else if (value && typeof value === 'object') {
            if (resolvedExplode) {
                objects.push({
                    name,
                    value: prefix + objectJoin(value, '=', separator),
                });
            }
            else {
                objects.push({
                    name,
                    value: prefix + paramId + objectJoin(value),
                });
            }
        }
    }
    return objects;
};
const formatSamples = function (sample) {
    const params = [];
    Object.keys(sample).map((key) => {
        if (Array.isArray(sample[key])) {
            sample[key].forEach((entry) => {
                params.push({
                    name: `${key}[]`,
                    value: entry,
                });
            });
        }
        else if (Object.prototype.toString.call(sample[key]) === '[object Object]') {
            Object.keys(sample[key]).map((k) => {
                if (Array.isArray(sample[key][k])) {
                    sample[key][k].forEach((entry) => {
                        params.push({
                            name: `${key}[${k}][]`,
                            value: entry,
                        });
                    });
                }
                else {
                    params.push({
                        name: key + '[' + k + ']',
                        value: sample[key][k],
                    });
                }
            });
        }
        else {
            params.push({
                name: key,
                value: sample[key],
            });
        }
    });
    return params;
};
const getPayloads = function (openApi, path, method) {
    if (typeof openApi.paths[path][method].parameters !== 'undefined') {
        for (let i in openApi.paths[path][method].parameters) {
            const param = openApi.paths[path][method].parameters[i];
            if (typeof param.in !== 'undefined' &&
                param.in.toLowerCase() === 'body' &&
                typeof param.schema !== 'undefined') {
                try {
                    const sample = _sample(param.schema, { skipReadOnly: true }, openApi);
                    return [
                        {
                            mimeType: 'application/json',
                            text: JSON.stringify(sample),
                        },
                    ];
                }
                catch (err) {
                    console.log(err);
                    return [];
                }
            }
        }
    }
    if (openApi.paths[path][method].requestBody &&
        openApi.paths[path][method].requestBody['$ref']) {
        openApi.paths[path][method].requestBody = resolveRef(openApi, openApi.paths[path][method].requestBody['$ref']);
    }
    const payloads = [];
    if (openApi.paths[path][method].requestBody &&
        openApi.paths[path][method].requestBody.content) {
        [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data',
        ].forEach((type) => {
            const content = openApi.paths[path][method].requestBody.content[type];
            if (content && content.schema) {
                const sample = _sample(content.schema, { skipReadOnly: true }, openApi);
                if (type === 'application/json') {
                    payloads.push({
                        mimeType: type,
                        text: JSON.stringify(sample),
                    });
                }
                else if (type === 'multipart/form-data') {
                    if (sample !== undefined && sample !== null) {
                        const params = [];
                        Object.keys(sample).forEach((key) => {
                            let value = sample[key];
                            if (typeof sample[key] !== 'string') {
                                value = JSON.stringify(sample[key]);
                            }
                            params.push({ name: key, value: value });
                        });
                        payloads.push({
                            mimeType: type,
                            params: params,
                        });
                    }
                }
                else if (type == 'application/x-www-form-urlencoded') {
                    if (sample === undefined || sample === null)
                        return;
                    const params = formatSamples(sample);
                    payloads.push({
                        mimeType: 'application/x-www-form-urlencoded',
                        params: params,
                        text: Object.keys(params)
                            .map((key) => key + '=' + sample[key])
                            .join('&'),
                    });
                }
            }
        });
    }
    return payloads;
};
const getBaseUrl = function (openApi, path, method) {
    if (openApi.paths[path][method].servers)
        return openApi.paths[path][method].servers[0].url;
    if (openApi.paths[path].servers)
        return openApi.paths[path].servers[0].url;
    if (openApi.servers)
        return openApi.servers[0].url;
    let baseUrl = '';
    if (typeof openApi.schemes !== 'undefined') {
        baseUrl += openApi.schemes[0];
    }
    else {
        baseUrl += 'http';
    }
    if (openApi.basePath === '/') {
        baseUrl += '://' + openApi.host;
    }
    else {
        baseUrl += '://' + openApi.host + openApi.basePath;
    }
    return baseUrl;
};
const getParameterValues = function (openApi, param, location, values) {
    let value = 'SOME_' + (param.type || param.schema.type).toUpperCase() + '_VALUE';
    if (location === 'path') {
        value = `{${param.name}}`;
    }
    if (values && typeof values[param.name] !== 'undefined') {
        value = values[param.name];
    }
    else if (typeof param.example !== 'undefined') {
        value = param.example;
    }
    else if (typeof param.examples !== 'undefined') {
        let firstExample = Object.values(param.examples)[0];
        if (typeof firstExample['$ref'] === 'string' &&
            /^#/.test(firstExample['$ref'])) {
            firstExample = resolveRef(openApi, firstExample['$ref']);
        }
        value = firstExample.value;
    }
    else if (typeof param.schema !== 'undefined' &&
        typeof param.schema.example !== 'undefined') {
        value = param.schema.example;
    }
    else if (typeof param.default !== 'undefined') {
        value = param.default;
    }
    return createHarParameterObjects(param, value);
};
const parseParametersToQuery = function (openApi, parameters, location, values) {
    const queryStrings = {};
    for (let i in parameters) {
        let param = parameters[i];
        if (typeof param['$ref'] === 'string' && /^#/.test(param['$ref'])) {
            param = resolveRef(openApi, param['$ref']);
        }
        if (typeof param.schema !== 'undefined') {
            if (typeof param.schema['$ref'] === 'string' &&
                /^#/.test(param.schema['$ref'])) {
                param.schema = resolveRef(openApi, param.schema['$ref']);
                if (typeof param.schema.type === 'undefined') {
                    param.schema.type = 'object';
                }
            }
        }
        if (typeof param.in !== 'undefined' &&
            param.in.toLowerCase() === location) {
            queryStrings[param.name] = getParameterValues(openApi, param, location, values);
        }
    }
    return queryStrings;
};
const getParameterCollectionIn = function (openApi, path, method, location, values) {
    if (typeof values === 'undefined') {
        values = {};
    }
    let pathParameters = {};
    let operationParameters = {};
    if (typeof openApi.paths[path].parameters !== 'undefined') {
        pathParameters = parseParametersToQuery(openApi, openApi.paths[path].parameters, location, values);
    }
    if (typeof openApi.paths[path][method].parameters !== 'undefined') {
        operationParameters = parseParametersToQuery(openApi, openApi.paths[path][method].parameters, location, values);
    }
    const queryStrings = Object.assign(pathParameters, operationParameters);
    return Object.values(queryStrings).flatMap((entry) => entry);
};
const getQueryStrings = function (openApi, path, method, values) {
    return getParameterCollectionIn(openApi, path, method, 'query', values);
};
const getFullPath = function (openApi, path, method) {
    let fullPath = path;
    const pathParameters = getParameterCollectionIn(openApi, path, method, 'path');
    pathParameters.forEach(({ name, value }) => {
        fullPath = fullPath.replace('{' + name + '}', value);
    });
    return fullPath;
};
const getCookies = function (openApi, path, method) {
    return getParameterCollectionIn(openApi, path, method, 'cookie');
};
const getHeadersArray = function (openApi, path, method) {
    const headers = [];
    const pathObj = openApi.paths[path][method];
    if (typeof pathObj.consumes !== 'undefined') {
        for (let i in pathObj.consumes) {
            const type = pathObj.consumes[i];
            headers.push({
                name: 'accept',
                value: type,
            });
        }
    }
    headers.push(...getParameterCollectionIn(openApi, path, method, 'header'));
    let basicAuthDef;
    let apiKeyAuthDef;
    let oauthDef;
    if (typeof pathObj.security !== 'undefined') {
        for (var l in pathObj.security) {
            const secScheme = Object.keys(pathObj.security[l])[0];
            const secDefinition = openApi.securityDefinitions
                ? openApi.securityDefinitions[secScheme]
                : openApi.components.securitySchemes[secScheme];
            const authType = secDefinition.type.toLowerCase();
            let authScheme = null;
            if (authType !== 'apikey' && secDefinition.scheme != null) {
                authScheme = secDefinition.scheme.toLowerCase();
            }
            switch (authType) {
                case 'basic':
                    basicAuthDef = secScheme;
                    break;
                case 'apikey':
                    if (secDefinition.in === 'header') {
                        apiKeyAuthDef = secDefinition;
                    }
                    break;
                case 'oauth2':
                    oauthDef = secScheme;
                    break;
                case 'http':
                    switch (authScheme) {
                        case 'bearer':
                            oauthDef = secScheme;
                            break;
                        case 'basic':
                            basicAuthDef = secScheme;
                            break;
                    }
                    break;
            }
        }
    }
    else if (typeof openApi.security !== 'undefined') {
        for (let m in openApi.security) {
            const secScheme = Object.keys(openApi.security[m])[0];
            const secDefinition = openApi.components.securitySchemes[secScheme];
            const authType = secDefinition.type.toLowerCase();
            let authScheme = null;
            if (authType !== 'apikey' && authType !== 'oauth2') {
                authScheme = secDefinition.scheme.toLowerCase();
            }
            switch (authType) {
                case 'http':
                    switch (authScheme) {
                        case 'bearer':
                            oauthDef = secScheme;
                            break;
                        case 'basic':
                            basicAuthDef = secScheme;
                            break;
                    }
                    break;
                case 'basic':
                    basicAuthDef = secScheme;
                    break;
                case 'apikey':
                    if (secDefinition.in === 'header') {
                        apiKeyAuthDef = secDefinition;
                    }
                    break;
                case 'oauth2':
                    oauthDef = secScheme;
                    break;
            }
        }
    }
    if (basicAuthDef) {
        headers.push({
            name: 'Authorization',
            value: 'Basic ' + 'REPLACE_BASIC_AUTH',
        });
    }
    else if (apiKeyAuthDef) {
        headers.push({
            name: apiKeyAuthDef.name,
            value: 'REPLACE_KEY_VALUE',
        });
    }
    else if (oauthDef) {
        headers.push({
            name: 'Authorization',
            value: 'Bearer ' + 'REPLACE_BEARER_TOKEN',
        });
    }
    return headers;
};
const openApiToHarList = function (openApi) {
    try {
        const harList = [];
        for (let path in openApi.paths) {
            for (let method in openApi.paths[path]) {
                const url = getBaseUrl(openApi, path, method) + path;
                const hars = createHar(openApi, path, method);
                harList.push({
                    method: method.toUpperCase(),
                    url: url,
                    description: openApi.paths[path][method].description ||
                        'No description available',
                    hars: hars,
                });
            }
        }
        return harList;
    }
    catch (e) {
        console.log(e);
        return [];
    }
};
const resolveRef = function (openApi, ref) {
    const parts = ref.split('/');
    if (parts.length <= 1)
        return {};
    const recursive = function (obj, index) {
        if (index + 1 < parts.length) {
            let newCount = index + 1;
            return recursive(obj[parts[index]], newCount);
        }
        else {
            return obj[parts[index]];
        }
    };
    return recursive(openApi, 1);
};
export const getAll = openApiToHarList;
export const getEndpoint = createHar;
